/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Badge } from '../../../index';
import type { Props as BadgeProps } from '../../display/Badge/Badge';

const badgeOverrides = css({
  '& > span': {
    minWidth: '26px !important',
  },
});

export default function PageNavigationBadge(props: BadgeProps) {
  return (
    <span css={badgeOverrides}>
      <Badge {...props}></Badge>
    </span>
  );
}
